// extracted by mini-css-extract-plugin
export default {"banner":"CookieBanner_banner__Nn3pE","container":"CookieBanner_container__bdjTX"};